import loadable from '@loadable/component'
import { injectReducer } from 'store/reducers'

const getDefaultExport = (module) => module.default || module

export const createLazyRouteComponent = ({
  store,
  reducerKey,
  loadReducer,
  loadComponent,
  reducers,
  fallback = null,
}) =>
  loadable(
    async () => {
      const reducerConfigs =
        reducers || (reducerKey && loadReducer ? [{ key: reducerKey, loadReducer }] : [])
      const modules = await Promise.all([
        ...reducerConfigs.map(({ loadReducer: loadRouteReducer }) => loadRouteReducer()),
        loadComponent(),
      ])

      reducerConfigs.forEach(({ key }, index) => {
        injectReducer(store, {
          key,
          reducer: getDefaultExport(modules[index]),
        })
      })

      return modules[modules.length - 1]
    },
    { fallback }
  )
